/* __next_internal_client_entry_do_not_use__ Truck auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1613))
 * @trackcomponent
 * @donotsync Syncing adds default color (@quinlan.sokol)
 */ export var Truck = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20C18.4696 20 17.9609 19.7893 17.5858 19.4142C17.2107 19.0391 17 18.5304 17 18C17 17.4696 17.2107 16.9609 17.5858 16.5858C17.9609 16.2107 18.4696 16 19 16C19.5304 16 20.0391 16.2107 20.4142 16.5858C20.7893 16.9609 21 17.4696 21 18V18Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M7 18C7 18.5304 6.78929 19.0391 6.41421 19.4142C6.03914 19.7893 5.53043 20 5 20C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18C3 17.4696 3.21071 16.9609 3.58579 16.5858C3.96086 16.2107 4.46957 16 5 16C5.53043 16 6.03914 16.2107 6.41421 16.5858C6.78929 16.9609 7 17.4696 7 18Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M21 18H22.5C22.7652 18 23.0196 17.8946 23.2071 17.7071C23.3946 17.5196 23.5 17.2652 23.5 17V13.015C23.5002 12.8556 23.4622 12.6985 23.3894 12.5567C23.3165 12.4149 23.2107 12.2926 23.081 12.2L20 11L19.189 6.757C19.1348 6.54075 19.01 6.34881 18.8342 6.21166C18.6585 6.0745 18.4419 6.00001 18.219 6H14.5V5C14.5 4.73478 14.3946 4.48043 14.2071 4.29289C14.0196 4.10536 13.7652 4 13.5 4H1.5C1.23478 4 0.980429 4.10536 0.792892 4.29289C0.605356 4.48043 0.5 4.73478 0.5 5V17C0.5 17.2652 0.605356 17.5196 0.792892 17.7071C0.980429 17.8946 1.23478 18 1.5 18H3",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M17 18H7",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M14.5 6V16",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M23.5 15H22",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M20 11H14.5",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Truck", {
    viewBox: "0 0 24 24",
    fill: "none"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
